import type { SharedApiV2 } from "@capstone/mock-api";
import { DashboardTicketSite } from "src/app/partner/help-assist/dashboard-help-assist-site.model";
import { AppointmentApproval } from "src/app/partner/help-assist/models/ticket-appointment-approval.model";
import { DashboardTicketScheduleTicketAppointment } from "src/app/partner/help-assist/models/ticket-appointment-draft/dashboard-ticket-schedule-ticket-appointment.model";

export class DashboardHelpAssistTicketSchedule {
  private constructor(
    args: ClassProperties<DashboardHelpAssistTicketSchedule>,
  ) {
    this.appointment = args.appointment;
    this.ticketAppointment = args.ticketAppointment;
  }

  public readonly appointment: DashboardHelpAssistTicketScheduleAppointment | null;
  public readonly ticketAppointment: DashboardTicketScheduleTicketAppointment | null;

  public static deserialize(
    apiModel: ApiDashboardHelpAssistTicketSchedule,
    { site }: DashboardHelpAssistTicketScheduleDeserializeArguments,
  ): DashboardHelpAssistTicketSchedule {
    return new DashboardHelpAssistTicketSchedule({
      appointment:
        apiModel.appointment && apiModel.appointmentId
          ? deserializeDashboardHelpAssistTicketScheduleAppointment(
              apiModel.appointment,
              {
                appointmentId: apiModel.appointmentId,
                partnerKey: site.partner.key.toString(),
              },
            )
          : null,
      ticketAppointment: apiModel.ticketAppointment
        ? DashboardTicketScheduleTicketAppointment.deserialize(
            apiModel.ticketAppointment,
            { site },
          )
        : null,
    });
  }
}

type ApiDashboardHelpAssistTicketSchedule = SharedApiV2.AppointmentScheduleDto;

interface DashboardHelpAssistTicketScheduleDeserializeArguments {
  readonly site: DashboardTicketSite;
}

interface DashboardHelpAssistTicketScheduleAppointmentDeserializeArguments {
  readonly appointmentId: number;
  readonly partnerKey: string;
}

export function deserializeDashboardHelpAssistTicketScheduleAppointment(
  data: SharedApiV2.TicketScheduleAppointmentDto,
  {
    appointmentId,
    partnerKey,
  }: DashboardHelpAssistTicketScheduleAppointmentDeserializeArguments,
): DashboardHelpAssistTicketScheduleAppointment {
  return {
    appointmentApproval: data.appointmentApproval
      ? AppointmentApproval.deserialize({
          ...data.appointmentApproval,
          appointmentId,
          partnerKey,
        })
      : null,
    loadNumber: data.clientAppointmentNumber || null,
    loadType: data.loadType || null,
    totalCaseCount: data.totalCaseCount,
    totalWarehousePalletCount: data.totalPalletCount,
  };
}

export interface DashboardHelpAssistTicketScheduleAppointment {
  readonly appointmentApproval: AppointmentApproval | null;
  readonly loadNumber: string | null;
  readonly loadType: string | null;
  readonly totalCaseCount: number;
  readonly totalWarehousePalletCount: number;
}
